import React, { useEffect, useState } from "react";
import axiosInstance from "../../services/auth";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";
import "./Location.css";
import { useCombinedContext } from "../../context/CombinedContext";

const Location = () => {
  const [location, setLocation] = useState([]);
  const [filterLocation, setFilterLocation] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [isViewMode, setIsViewMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [loadingButton, setLoadingButton] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const [locationData, setLocationData] = useState({
    code: "",
    yard_name: "",
    address: "",
    country: "",
    pincode: "",
  });
  const [loading, setLoading] = useState(false);
  const { locations, setLocations } = useCombinedContext();
  // console.log("locations",locations)
  // Get All Job Location
  // Get All Job Location
  const getAllLocation = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/location");
      const fetchedLocations = response.data.data || [];
      setLocation(fetchedLocations);
      setFilterLocation(fetchedLocations);
      setLocations(fetchedLocations);
    } catch (error) {
      // console.error("Error fetching location", error);
      toast.error("Error fetching location");
    } finally {
      setLoading(false);
    }
  };

  // Filter Job Location
  const handleSearchChange = (e) => {
    const searchText = e.target.value.toLowerCase();
    const filteredLocation = location.filter(
      (location) =>
        location.code.toString().toLowerCase().includes(searchText) ||
        location.yard_name.toString().toLowerCase().includes(searchText) ||
        location.address.toString().toLowerCase().includes(searchText),
    );
    setFilterLocation(filteredLocation);
  };
  // Handle Delete
  const handleDelete = (id) => {
    setDeleteTarget(id); // Set the target ID for deletion
    setIsDeleteModalOpen(true);
  };

  // Confirm Delete
  const confirmDelete = async () => {
    if (!deleteTarget) return; // Ensure a valid target is set
    try {
      await axiosInstance.delete(`/location/${deleteTarget}`);
      setLocation((prev) => prev.filter((loc) => loc._id !== deleteTarget));
      setFilterLocation((prev) =>
        prev.filter((loc) => loc._id !== deleteTarget),
      );
      setIsDeleteModalOpen(false); // Close the modal after successful deletion
      setDeleteTarget(null); // Clear the delete target
      toast.success("Location deleted successfully");
    } catch (error) {
      // console.error("Error deleting location:", error);
      toast.error("Failed to delete location");
    }
  };

  //Add Job Location
  const handleAddLocation = () => {
    setLocationData({
      code: "",
      yard_name: "",
      address: "",
      country: "",
      pincode: "",
    });
    setIsViewMode(false);
    setIsModelOpen(true);
  };

  //Add Job Location
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Check if all fields are filled
    if (
      !locationData.code ||
      !locationData.yard_name ||
      !locationData.address ||
      !locationData.country ||
      !locationData.pincode
    ) {
      toast.error("All fields are required!");
      return;
    }
    setLoadingButton(true);
    try {
      if (locationData._id) {
        const location = await axiosInstance.patch(
          `/location/${locationData._id}`,
          locationData,
        );
        // console.log("id is ", locationData._id);
        toast.success("Location updated successfully");
      } else {
        const location = await axiosInstance.post("/location", locationData);
        // console.log(location);
        toast.success("Location added successfully");
      }
      closeModel();
      setLocationData({
        code: "",
        yard_name: "",
        address: "",
        country: "",
        pincode: "",
      });
    } catch (error) {
      // console.log(error);
    } finally {
      setLoadingButton(false);
    }
  };
  //Update Job Location
  const handleUpdate = async (data) => {
    setLocationData(data);
    setIsViewMode(false);
    setIsModelOpen(true);
  };
  //Close Model
  const closeModel = () => {
    setIsModelOpen(false);
    getAllLocation();
  };

  //view Job Location

  const handleView = (data) => {
    setLocationData(data);
    setIsViewMode(true);
  };

  //Handle Page Location
  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };
  // const itemsPerPage = 5;
  const currentItems = [...filterLocation]
    .reverse()
    .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
  const pageCount = Math.ceil(filterLocation.length / itemsPerPage);

  // useEffect
  useEffect(() => {
    getAllLocation();
  }, []);
  useEffect(() => {
    setLocations(location); // This might not work correctly if location is not updated
  }, [location]);

  const authData =
    JSON.parse(localStorage.getItem("authData")) ||
    JSON.parse(sessionStorage.getItem("authData"));

  const userRole = authData.role;

  return (
    <div>
      <ToastContainer />
      <div className="mb-4 headStyle d-flex  justify-content-between align-items-cente">
        <h4 className="mb-0">Job Location</h4>
        {["admin", "superadmin"].includes(userRole) && (
          <button onClick={handleAddLocation} className="button-2 ">
            Add Location
          </button>
        )}
      </div>
      <div className="headStyle">
        <div className="d-flex  align-items-center mt-3">
          <div className="d-flex">
            <input
              className="form-control me-3"
              type="search"
              placeholder="Search..."
              style={{ maxWidth: "200px", border: "1px solid #1E2A5E" }}
              onChange={handleSearchChange}
            />
            <div className="d-flex align-items-center">
              <label className="me-2 pt-1">Count</label>
              <select
                className="form-select no-arrow"
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                style={{ width: "auto" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
              </select>
            </div>
          </div>
        </div>

        {/* Table */}
        <div
          className="my-3 rounded"
          style={{
            overflowX: "auto",
          }}
        >
          <table className="table mb-0">
            <thead className="t_head">
              <tr>
                <th scope="col">S No</th>
                <th scope="col">Code</th>
                <th scope="col">Yard Name</th>
                <th scope="col">Address</th>
                <th scope="col">Country</th>
                <th scope="col">Pincode</th>
                <th scope="col" className="text-center">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7">
                    <div className="d-flex justify-content-center m-3">
                      <div className="spinner"></div>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {currentItems.length === 0 ? (
                    <>
                      <tr>
                        <td colSpan="7">
                          <div className="d-flex justify-content-center m-1">
                            <h6>Data Not Found</h6>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {currentItems &&
                        currentItems.map((data, index) => (
                          <tr key={data._id} className="">
                            {/* Serial Number */}
                            <td className="">
                              {currentPage * itemsPerPage + index + 1}
                            </td>

                            {/* Code */}
                            <td>{data.code}</td>

                            {/* Yard Name */}
                            <td className="">{data.yard_name}</td>

                            {/* Address */}
                            <td className="" style={{ maxWidth: "200px" }}>
                              {data.address}
                            </td>
                            <td className="" style={{ maxWidth: "200px" }}>
                              {data.country}
                            </td>
                            <td className="" style={{ maxWidth: "200px" }}>
                              {data.pincode}
                            </td>

                            {/* Actions */}
                            <td className="text-center">
                              <button
                                onClick={() => handleView(data)}
                                className="btn btn-outline-primary btn-sm me-2"
                                title="View Details"
                              >
                                <i className="bi bi-folder2-open"></i>
                              </button>
                              <button
                                onClick={() => handleUpdate(data)}
                                className="btn btn-outline-success btn-sm me-2"
                                title="Edit Details"
                              >
                                <i className="bi bi-pencil-square"></i>
                              </button>
                              {["admin", "superadmin"].includes(userRole) && (
                                <button
                                  onClick={() => handleDelete(data._id)}
                                  className="btn btn-outline-danger btn-sm"
                                  title="Delete Entry"
                                >
                                  <i className="bi bi-trash3"></i>
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                    </>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>

        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          containerClassName="pagination justify-content-center pagination-sm"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          disabledClassName="disabled"
        />

        {isModelOpen && (
          <div
            className={`modal fade ${isModelOpen ? "show d-block" : ""}`}
            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            id="exampleModalCenter"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden={!isModelOpen}
            onClick={(e) => {
              if (e.target.classList.contains("modal")) setIsModelOpen(false); // Close on outside click
            }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title w-100 text-center">
                    {locationData._id
                      ? "Update Job Location"
                      : "Add Job Location"}
                  </h5>

                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setIsModelOpen(false)} // Close modal
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="modalDiv">
                    <form
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent default form submission
                          handleSubmit(e); // Trigger submit handler
                        }
                      }}
                      required
                    >
                      <div className="mb-3">
                        <label
                          htmlFor="code"
                          className="form-label model_form_label"
                        >
                          Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="code"
                          value={locationData.code}
                          onChange={(e) =>
                            setLocationData({
                              ...locationData,
                              code: e.target.value,
                            })
                          }
                          readOnly={isViewMode} // Make field read-only in view mode
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="yardName"
                          className="form-label model_form_label"
                        >
                          Yard Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="yardName"
                          value={locationData.yard_name}
                          onChange={(e) =>
                            setLocationData({
                              ...locationData,
                              yard_name: e.target.value,
                            })
                          }
                          required
                          readOnly={isViewMode} // Make field read-only in view mode
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="address"
                          className="form-label model_form_label"
                        >
                          Address
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          value={locationData.address}
                          onChange={(e) =>
                            setLocationData({
                              ...locationData,
                              address: e.target.value,
                            })
                          }
                          required
                          readOnly={isViewMode} // Make field read-only in view mode
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="address"
                          className="form-label model_form_label"
                        >
                          Country
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="country"
                          value={locationData.country}
                          onChange={(e) =>
                            setLocationData({
                              ...locationData,
                              country: e.target.value,
                            })
                          }
                          required
                          readOnly={isViewMode} // Make field read-only in view mode
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="address"
                          className="form-label model_form_label"
                        >
                          Pincode
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="pincode"
                          value={locationData.pincode}
                          onChange={(e) =>
                            setLocationData({
                              ...locationData,
                              pincode: e.target.value,
                            })
                          }
                          required
                          readOnly={isViewMode} // Make field read-only in view mode
                        />
                      </div>
                    </form>
                  </div>
                </div>
                <div className="modal-footer d-flex justify-content-center">
                  {isViewMode ? (
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setIsModelOpen(false)}
                    >
                      Close
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="button-2"
                      onClick={handleSubmit}
                      disabled={loadingButton}
                    >
                      {loadingButton
                        ? locationData._id
                          ? "Updating"
                          : "Adding"
                        : locationData._id
                          ? "Update"
                          : "Add"}
                      {}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {isViewMode && (
          <div
            className={`modal fade ${isViewMode ? "show d-block" : ""}`}
            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            id="exampleModalCenter"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden={!isViewMode}
            onClick={(e) => {
              if (e.target.classList.contains("modal")) setIsViewMode(false); // Close on outside click
            }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div
                className="modal-content"
                style={{ backgroundColor: "#f8f9fa", borderRadius: "10px" }}
              >
                <div
                  className="modal-header"
                  style={{ borderBottom: "2px solid #dee2e6" }}
                >
                  <h5
                    className="modal-title w-100 text-center"
                    style={{ fontWeight: "bold", color: "#343a40" }}
                  >
                    Job Location
                  </h5>

                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setIsViewMode(false)} // Close modal on button click
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="modalDiv">
                    <div className="mb-3">
                      <h6
                        className="form-label"
                        style={{ fontSize: "1.1rem", fontWeight: "600" }}
                      >
                        <strong className="view-title">Code:</strong>{" "}
                        {locationData.code}
                      </h6>
                    </div>
                    <div className="mb-3">
                      <h6
                        className="form-label"
                        style={{ fontSize: "1.1rem", fontWeight: "600" }}
                      >
                        <strong className="view-title">Yard Name:</strong>{" "}
                        {locationData.yard_name}
                      </h6>
                    </div>
                    <div className="mb-3">
                      <h6
                        className="form-label"
                        style={{ fontSize: "1.1rem", fontWeight: "600" }}
                      >
                        <strong className="view-title">Address:</strong>{" "}
                        {locationData.address}
                      </h6>
                    </div>
                    <div className="mb-3">
                      <h6
                        className="form-label"
                        style={{ fontSize: "1.1rem", fontWeight: "600" }}
                      >
                        <strong className="view-title">Country:</strong>{" "}
                        {locationData.country}
                      </h6>
                    </div>
                    <div className="mb-3">
                      <h6
                        className="form-label"
                        style={{ fontSize: "1.1rem", fontWeight: "600" }}
                      >
                        <strong className="view-title">Pincode:</strong>{" "}
                        {locationData.pincode}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {isDeleteModalOpen && (
          <div
            className={`modal fade ${isDeleteModalOpen ? "show d-block" : ""}`}
            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="deleteModalLabel"
            aria-hidden={!isDeleteModalOpen}
            onClick={(e) => {
              if (e.target.classList.contains("modal"))
                setIsDeleteModalOpen(false);
            }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="deleteModalLabel">
                    Confirm Deletion
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setIsDeleteModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  Are you sure you want to delete this location? This action
                  cannot be undone.
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setIsDeleteModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-danger" onClick={confirmDelete}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Location;
